<template>
  <div
    id="line-chart"
    ref="lineChart"
    style="width: 100%; height: 400px;"
  ></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MultiLine",
  props: {
    data: {
      type: Object,
      required: true
    },
    darkmode: String
  },
  mounted() {
    this.initChart();
    this.$watch(
      "data",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
    this.$watch(
      "darkmode",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.lineChart);
      this.chart.setOption(this.getChartOption());
    },
    updateChart() {
      this.chart.setOption(this.getChartOption());
    },
    getChartOption() {
      return {
        title: {
          text: this.data?.title,
          left: "center",
          textStyle: {
            color: this.darkmode ? "#FFFFFF" : "#000000",
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: this.data.yValues
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "Renda",
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#32CD32"
            },
            itemStyle: {
              color: "#32CD32"
            },
            data: this.data.series1,
            markArea: {
              data: [
                [
                  {
                    yAxis: 0 // Início da faixa no eixo Y
                  },
                  {
                    yAxis: 456.33, // Fim da faixa no eixo Y
                    itemStyle: {
                      color: "#FFCBCB"
                    }
                  }
                ],
                [
                  {
                    yAxis: 456.33
                  },
                  {
                    yAxis: 585.33,
                    itemStyle: {
                      color: "#FFF2B2"
                    }
                  }
                ],
                [
                  {
                    yAxis: 585.33
                  },
                  {
                    itemStyle: {
                      color: "#C8FFC8"
                    }
                  }
                ]
              ]
            }
          },
          {
            name: "Despesas",
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#E53935"
            },
            itemStyle: {
              color: "#E53935"
            },
            data: this.data.series2
          }
        ]
      };
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
#line-chart {
  width: 100%;
  height: 100%;
}
</style>
